// extracted by mini-css-extract-plugin
export default {"container":"LastMatchesResults_container__6f21x","win":"LastMatchesResults_win__jBUgW","lose":"LastMatchesResults_lose__AjHkX","draw":"LastMatchesResults_draw__nUVT5"};